<script>
import ServiceEcomplaints from '@/services/srv-eComplaints'
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'

import html2pdf from 'html2pdf.js'

export default {
    data() {
    return{
      dSecQuestions: [ 
        this.$t('secQuestions.1'),
        this.$t('secQuestions.2'),
        this.$t('secQuestions.3'),
        this.$t('secQuestions.4'),
        this.$t('secQuestions.5'),
        this.$t('secQuestions.6'),
        this.$t('secQuestions.7')
      ]
    }
  },

  methods:{
    // Formatea la fecha
    fDateFormat(date){
      return new Date(date).toLocaleString()
    },

    // Formatea la fecha
    fDateFormat2(date){
      return new Date(date).toLocaleDateString()
    },

    // Formatea la fecha
    fTimeFormat(date){
      return new Date(date).toLocaleTimeString()
    },

    // Comprueba si un valor es nulo o undefined
    fCheckSingleValue(value){
      return !value
    },
    
    // Devuelve el color de la chip del estado
    // Posibles estados: 'NUEVA','TRAMITE', 'TRAMITE_FP', 'RESUELTA','RECHAZADA','ACEPTADA','REABIERTA'
    fGetStatusColor(status){
      if(status === 'RECHAZADA'){
        return 'chipStateIncomplete'
      } else if(status === 'RESUELTA' || status === 'ACEPTADA') {
        return 'chipStateComplete'     
      } else {
        return 'chipStateHalfcomplete'
      }
    },
    
    // Devuelve la etiqueta para el estado de la denuncia
    fGetStatusLabel(status){
      if (status === 'NUEVA'){ 
        return this.$t('labels.new')}
      else if (status.includes('TRAMITE')){ 
        return this.$t('labels.pending')}
      else if (status === 'RESUELTA'){ 
        return this.$t('labels.solved')}
      else if (status === 'RECHAZADA'){ 
        return this.$t('labels.rejected')}
      else if (status === 'ACEPTADA'){ 
        return this.$t('labels.accepted')}
      else if (status === 'REABIERTA'){ 
        return this.$t('labels.reopen')}
      else{ 
        return status } 
    },

    // Formatea el tamaño del fichero
    fShortSize(size){
      const valMegabyte = 1000000
      const sufixMegabyte = 'Mb'

      const valKilobyte = 1000
      const sufixKilobyte = 'Kb'

      const accuracy = 10

      let result = 0

      if (size > valMegabyte) {
        result = (Math.round( (size * accuracy) / (valMegabyte)) / accuracy).toFixed(2)
        return Intl.NumberFormat().format(result) + sufixMegabyte
      } else if (size > valKilobyte) {
        result = (Math.round( (size * accuracy) / (valKilobyte)) / accuracy).toFixed(2)
        return Intl.NumberFormat().format(result) + sufixKilobyte
      } else {
        result = (Math.round( size * accuracy) / accuracy).toFixed(2)
        return Intl.NumberFormat().format(result)
      }
    },

    // Formato de pdf
    fSetPdfData(response, fileName){
      const htmlTemplate = Buffer.from(response.dataRes.body, 'base64').toString()
      const container = document.createElement('div')
      container.innerHTML = htmlTemplate

      html2pdf()
        .set({
          margin: 10,
          image: { type: 'png' },
          html2canvas: { useCORS: true },
          filename: fileName + '.pdf',
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        })
        .from(container)
        .save()
    },

    // Llama al ws que devuelve la info del pdf
    fDownloadPdfFile(template, complaintId, fileName){
      const payload = {
        complaintId: complaintId,
        pdfTemplate: template
      }
      
      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.getComplaintPdf(payload).then(response => {
          this.fSetPdfData(response, fileName)
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }else{
        ServiceEcomplaints.getComplaintPdf(payload).then(response => {
          this.fSetPdfData(response, fileName)
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      } 
    }
  }
}
</script>